module.exports = __webpack_public_path__ + "media/images/icon_crown-328466964a0e5890cefc4c6d45d6ffe8.svg";